let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ligT4")).then(() => parcelRequire('i3AK8'));